function o(a){return t=>!a(t)}export{o as a};
